const pageNameKey = "dashboardTimeseriesInfoWithPopover";

export const dashboardTimeseriesInfoWithPopoverEn = {
  [pageNameKey]: {
    textLabel: "Timeseries Info",
    nodeName: "Node Name",
    tsId: "TS ID",
    nodeId: "Node ID",
    copiedToClipboardSnackBarMessage: "Copied to clipboard",
    nodeSnackBarError: "It was not possible to copy the text to the clipboard.",
    noDataMessage: "No Timeseries data available",
  },
};

export const dashboardTimeseriesInfoWithPopoverPtBr = {
  [pageNameKey]: {
    textLabel: "Informações da série temporal",
    nodeName: "Nome do nó",
    tsId: "ID do TS",
    nodeId: "ID do nó",
    copiedToClipboardSnackBarMessage: "Copiado para a área de transferência",
    nodeSnackBarError:
      "Não foi possível copiar o texto para a área de transferência.",
    noDataMessage: "Nenhum dado de série temporal disponível",
  },
};

export const dashboardTimeseriesInfoWithPopoverDe = {
  [pageNameKey]: {
    textLabel: "Zeitreihen-Info",
    nodeName: "Knotenname",
    tsId: "TS ID",
    nodeId: "Knoten ID",
    copiedToClipboardSnackBarMessage: "In die Zwischenablage kopiert",
    nodeSnackBarError:
      "Es war nicht möglich, den Text in die Zwischenablage zu kopieren.",
    noDataMessage: "Keine Zeitreihendaten verfügbar",
  },
};

export const dashboardTimeseriesInfoWithPopoverZhHans = {
  [pageNameKey]: {
    textLabel: "时间序列信息",
    nodeName: "节点名称",
    tsId: "TS ID",
    nodeId: "节点 ID",
    copiedToClipboardSnackBarMessage: "已复制到剪贴板",
    nodeSnackBarError: "无法将文本复制到剪贴板。",
    noDataMessage: "没有时间序列数据可用",
  },
};

export const dashboardTimeseriesInfoWithPopoverIt = {
  [pageNameKey]: {
    textLabel: "Informazioni sui dati",
    nodeName: "Nome del nodo",
    tsId: "TS ID",
    nodeId: "Nodo ID",
    copiedToClipboardSnackBarMessage: "Copiato negli appunti",
    nodeSnackBarError: "Non è stato possibile copiare il testo negli appunti.",
    noDataMessage: "Non ci sono dati disponibili",
  },
};

export const dashboardTimeseriesInfoWithPopoverEs = {
  [pageNameKey]: {
    textLabel: "Información de series temporales",
    nodeName: "Nombre del nodo",
    tsId: "TS ID",
    nodeId: "Nodo ID",
    copiedToClipboardSnackBarMessage: "Copiado al portapapeles",
    nodeSnackBarError: "No fue posible copiar el texto al portapapeles.",
    noDataMessage: "No hay datos de series temporales disponibles",
  },
};

export const dashboardTimeseriesInfoWithPopoverNl = {
  [pageNameKey]: {
    copiedToClipboardSnackBarMessage: "Naar klembord gekopieerd",
    noDataMessage: "Geen tijdreeksgegevens beschikbaar",
    nodeId: "Node-ID",
    nodeName: "Nodenaam",
    nodeSnackBarError:
      "Het was niet mogelijk om de tekst naar het klembord te kopiëren.",
    textLabel: "Tijdreeksinformatie",
    tsId: "TS-ID",
  },
};

export const dashboardTimeseriesInfoWithPopoverTr = {
  [pageNameKey]: {
    copiedToClipboardSnackBarMessage: "Panoya kopyalandı",
    noDataMessage: "Zaman Serisi verisi yok",
    nodeId: "Düğüm kimliği",
    nodeName: "Düğüm Adı",
    nodeSnackBarError: "Metni panoya kopyalamak mümkün olmadı.",
    textLabel: "Zaman Dizisi Bilgisi",
    tsId: "TS Kimliği",
  },
};
